interface ExportItem {
  [key: string]: string | number | boolean | null | undefined;
}

export class PrintService {
  // Print data
  public print(data: ExportItem[], title: string): void {
    try {
      console.log("=== PRINT SERVICE ===");
      console.log("Print Service - Data Size:", data.length);
      
      // Early validation
      if (!data || data.length === 0) {
        console.error("Print Service - No data to export");
        return;
      }
      
      // Inspect the first data item
      console.log("Print Service - First data item:", JSON.stringify(data[0], null, 2));
      
      // Create a temporary div to hold the table
      const printWindow = window.open('', '_blank');
      if (!printWindow) {
        throw new Error('Unable to open print window');
      }

      // We want to control the order of the columns to match the UI
      // Standard column order: Keyword, Volume, KD, CPC, Intent, followed by domains
      let orderedHeaders: string[] = [];
      const standardColumns = ["keyword", "volume", "kd", "cpc", "intent"];
      
      if (data.length > 0) {
        const allKeys = Array.from(
          new Set(data.flatMap(row => Object.keys(row)))
        );

        // Build ordered headers (standard first, then others)
        orderedHeaders = [
          ...standardColumns.filter(col => allKeys.includes(col)),
          ...allKeys.filter(key => !standardColumns.includes(key))
        ];

        // Filter out empty columns
        orderedHeaders = orderedHeaders.filter((key) =>
          data.some((row) => {
            const value = row[key];
            return value !== null && value !== undefined && value !== "" && value !== "—";
          })
        );

        console.log("Print Service - Final headers:", orderedHeaders);
      } else {
        orderedHeaders = standardColumns;
      }

      // Format the headers nicely
      const formattedHeaders = orderedHeaders.map(header => {
        // Format domain names to match UI display
        if (header.includes('.com') || header.includes('.org') || header.includes('.net')) {
          return header; // Keep domain names as they are
        }
        
        // Format other headers with proper capitalization
        return header.charAt(0).toUpperCase() + header.slice(1);
      });

      // Generate table rows from data in the correct order
      const tableRows = data.map(item => {
        return `<tr>${orderedHeaders.map(key => {
          const value = item[key];
          
          // Format the value based on its type
          let formattedValue = '';
          if (value === null || value === undefined) {
            formattedValue = '-';
          } else if (typeof value === 'number') {
            formattedValue = value.toLocaleString();
          } else {
            formattedValue = String(value);
          }
          
          return `<td>${formattedValue}</td>`;
        }).join('')}</tr>`;
      }).join('');

      const html = `
        <html>
          <head>
            <title>${title}</title>
            <style>
              body { font-family: Arial, sans-serif; margin: 20px; }
              table { width: 100%; border-collapse: collapse; margin-top: 20px; }
              th, td { border: 1px solid #ddd; padding: 8px; }
              th { background-color: #2c3e50; color: white; }
              h2 { color: #333; }
              tr:nth-child(even) { background-color: #f2f2f2; }
              @media print {
                body { padding: 15mm; }
                table { page-break-inside: auto; }
                tr { page-break-inside: avoid; page-break-after: auto; }
                thead { display: table-header-group; }
                tfoot { display: table-footer-group; }
              }
            </style>
          </head>
          <body>
            <h2>${title}</h2>
            <p><small>Generated on ${new Date().toLocaleDateString()} ${new Date().toLocaleTimeString()}</small></p>
            <table>
              <thead>
                <tr>${formattedHeaders.map(header => `<th>${header}</th>`).join('')}</tr>
              </thead>
              <tbody>
                ${tableRows}
              </tbody>
            </table>
          </body>
        </html>
      `;

      // Write to the new window and print
      printWindow.document.write(html);
      printWindow.document.close();
      
      // Wait for content to load before printing
      printWindow.onload = () => {
        printWindow.print();
      };
      
      console.log('Print initialized');
    } catch (error) {
      console.error('Error printing:', error);
      throw error;
    }
  }
}
